import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import ClippedBanger from './components/clippedBanger';
import Footer from "./components/footer";

export default class Services extends Component {
  render() {
    return (
      <div>
        <ClippedBanger
			title="Privacy Policy"
			backgroundImage="images/thankyou-back.jpg"
			height="half"
			/>
        <div className="light-grey-background medium-padding">
          <div className="max-width-container white-background small-padding">
          <div className="rte">
<meta charSet="utf-8" />
<h3 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>LAST UPDATED</strong>:&nbsp;JULY 15, 2021
</h3>
<p data-mce-fragment={1}>&nbsp;</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>Who We Are</strong>:&nbsp;Alpine Design,
  LLC and its subsidiaries and affiliates offer a variety of
  innovative, well-designed, technology solutions for water sports and outdoor
  brands.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>Scope</strong>:&nbsp;This Privacy Policy
  applies to personal information collected on Companies’
  websites (“Sites”) and any personal information we collect in connection
  with delivering our services (collectively, the “Services”). This
  Privacy Policy describes how the Company collects, uses, processes, and
  discloses your personal information in connection with the Services.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<p data-mce-fragment={1}>
  Please read this Privacy Policy carefully. By using this Site, you agree to
  this Privacy Policy. If you do not agree with this Privacy Policy, please do
  not use our Sites.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>Contact Us</strong>:&nbsp;If you have any
  questions or requests in connection with the Privacy Policy or other
  privacy-related matters,&nbsp;please contact us at
  info@alpine.design.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>TABLE OF CONTENTS</strong>
</h5>
<ol data-mce-fragment={1}>
  <li data-mce-fragment={1}>Region-Specific Disclosures</li>
  <li data-mce-fragment={1}>Collection of Personal Information</li>
  <li data-mce-fragment={1}>Use of Personal Information</li>
  <li data-mce-fragment={1}>Disclosure of Personal Information</li>
  <li data-mce-fragment={1}>Third-Party Services</li>
  <li data-mce-fragment={1}>Security of Your Information</li>
  <li data-mce-fragment={1}>Choices and Control Over Your Information</li>
  <li data-mce-fragment={1}>Children’s Privacy</li>
  <li data-mce-fragment={1}>Cookies and Similar Technologies</li>
  <li data-mce-fragment={1}>Data Transfers</li>
  <li data-mce-fragment={1}>Updates to this Privacy Policy</li>
</ol>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>1. REGION-SPECIFIC DISCLOSURES</strong>
</h5>
<p data-mce-fragment={1}>
  Certain states, regions or countries may have privacy laws that are
  different from the one in which you are located.&nbsp; Please note the
  disclosures that may apply to your use of the Services, as set forth below.
</p>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    If you are a resident of the U.S. State of Nevada, you have the right to
    ask us not to sell your covered information (as those terms are defined
    under Nevada law) that we have collected or will collect about you. We do
    not sell your covered information at this time. If you would like
    additional information, please contact us at info@alpine.design.
    Please see the Cookies and Similar Technologies section below for more
    information about the choices you may in relation to our use of cookies
    and related technologies.
  </li>
</ul>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>2. COLLECTION OF PERSONAL INFORMATION</strong>
</h5>
<p data-mce-fragment={1}>
  We collect personal information about you in various ways when you interact
  with the Services. The types of personal information we collect and the
  manner in which we collect it depends on the nature of your interaction with
  the Services and the specific Company with which you interact.
</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    <i data-mce-fragment={1}>Personal Information You Provide to Us</i>
  </strong>
  :
</p>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>
      Contact and other identifying information
    </strong>
    : The Companies may collect personal information such as your name,
    address, zip code, phone number, and email address when you purchase a
    product from us or register for the Services, submit information through
    our warranty registration process, take advantage of or participate in an
    offer or promotional activity, sign up for our newsletters, or otherwise
    communicate with us or interact with the Services.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Account information</strong>: Certain
    Companies may collect your username and password when you register for
    their Services.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Payment and transaction information</strong>
    : Certain Companies may collect personal information such as products
    purchased, amount purchased, order details, the third-party dealer from
    whom you purchased a product, and payment information when purchase a
    product from the Services or submit information through our warranty
    registration process. Payments may be processed by our third-party payment
    processors. Please refer to the applicable processor’s privacy policy for
    information about how your payment information may be processed and
    stored.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>
      Inquiry and communication information
    </strong>
    : The Companies may collect the content of your email, live chat or
    contact form submission on the Services, and, where applicable, recordings
    of calls with us when you contact us.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Location information</strong>: Certain
    Companies may collect information about your physical location, such as
    when you upload this information to the Services or when you use our
    dealer locator tool to identify nearby sellers of the Company products.
  </li>
</ul>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    <i data-mce-fragment={1}>Information We Receive Automatically</i>
  </strong>
  :
</p>
<p data-mce-fragment={1}>
  The Companies may collect personal information from you automatically when
  you visit or use the Services. Such information may include:
</p>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Device and usage information</strong>. The
    Companies may collect and store information about the devices you use and
    usage statistics about how you interact with the Services. This
    information may include Internet protocol (IP) addresses, browser type,
    Internet service provider (ISP), device identifier, referring/exit pages,
    the files viewed on our site (e.g., HTML pages, graphics, etc.), operating
    system, date/time stamp, and/or clickstream data.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Analytics information</strong>.&nbsp;The
    Companies and their partners use cookies, pixels, server logs, and other
    similar technology to analyze trends, administer the Sites, track users’
    movements around our Sites, and to gather demographic information about
    our user base as a whole.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Location information</strong>: The Companies
    may collect your general location information based on your IP address.
  </li>
</ul>
<p data-mce-fragment={1}>
  We may use cookies and other technologies to collect information
  automatically. Please see the Cookies and Similar Technologies section below
  for more information.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    <i data-mce-fragment={1}>
      Personal Information We Receive from Other Sources and Third Parties
    </i>
  </strong>
  :
</p>
<p data-mce-fragment={1}>
  We may also obtain personal information from other sources, which we often
  combine with personal information we receive either automatically or
  directly from you. We may receive the same categories of personal
  information as described above from the following sources and third parties:
</p>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Social Media Networks</strong>: We may
    receive information about you when you interact with the Services through
    various social media networks.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Service Providers</strong>: We may receive
    information about you from our service providers that perform services on
    our behalf, such as analytics or payment processors.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Other Third Parties</strong>: From time to
    time, we may receive information about you from third parties. For
    example, a Company may obtain information from marketing partners or other
    third parties to enhance or supplement our existing user information. We
    may combine this personal information with the personal information we
    collect from you directly.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Dealers</strong>: When you purchase one of
    our products from a third-party dealer we may receive your shipping
    information in order to fulfill your order.
  </li>
</ul>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>3. USE OF PERSONAL INFORMATION</strong>
</h5>
<p data-mce-fragment={1}>
  The Companies may use the Personal Information we process for various
  purposes, including, without limitation, to:
</p>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    provide, maintain and improve the features and functionality of the
    Services;
  </li>
  <li data-mce-fragment={1}>
    perform our contractual obligations and enforce our rights arising from
    any contracts entered into between you and the Companies and as we believe
    necessary or appropriate to protect, enforce or defend the legal rights,
    privacy, safety or property of the Services, our employees or agents, or
    other users.
  </li>
  <li data-mce-fragment={1}>
    communicate with you and send you important information regarding the
    Services, such as certain changes to our terms, conditions, policies,
    and/or other administrative information. Because this information may be
    material to your use of the Services, you may not opt out of receiving
    such communications.
  </li>
  <li data-mce-fragment={1}>
    fulfill or meet the information was provided, such as to process your
    orders and payment in connection with your transactions, respond to
    inquiries, process your warranty or rebate claims and registration for the
    Services, including verifying your information to ensure its accuracy and
    validity.
  </li>
  <li data-mce-fragment={1}>
    perform internal business purposes, such as to conduct internal research
    and development and make business decisions about current and future
    product and service offerings.
  </li>
  <li data-mce-fragment={1}>
    respond to your comments, questions and requests and provide customer
    service.
  </li>
  <li data-mce-fragment={1}>
    administer the Services, offers, promotions, rewards, and events that we
    believe may be of interest to you, including, without limitation, adding
    you to our mailing lists and permitting you to participate in contests,
    rebates and similar promotions.
  </li>
  <li data-mce-fragment={1}>
    inform you of products, programs and services that we believe may be of
    interest to you.
  </li>
  <li data-mce-fragment={1}>
    personalize your experience (e.g., to locate a nearby dealer of Company
    products) and customize content on the Services relevant to your
    interests, including but not limited to targeted offers and ads through
    our Sites, email, social media channels, third-party sites, or on other
    devices you may use.
  </li>
  <li data-mce-fragment={1}>
    monitor and analyze trends, usage and activities.
  </li>
  <li data-mce-fragment={1}>
    detect, protect against and prevent security incidents and illegal or
    unauthorized activities, investigate complaints and claims, and provide
    other security protections, such as identity verification.
  </li>
  <li data-mce-fragment={1}>
    comply with and enforce applicable legal and regulatory obligations, and
    respond to governmental requests.
  </li>
  <li data-mce-fragment={1}>
    carry out any other purpose readily apparent to you or described to you at
    the time the personal information is collected or as otherwise set forth
    in this Privacy Policy.
  </li>
</ul>
<p data-mce-fragment={1}>
  We may also use aggregate personal information in a manner such that the
  end-product does not uniquely identify you or any other user of
  the&nbsp;Services.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>4. DISCLOSURE OF PERSONAL INFORMATION</strong>
</h5>
<p data-mce-fragment={1}>
  We may share your personal information with third parties for various
  purposes, including without limitation:
</p>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Service Providers</strong>: We may disclose
    personal information with third-party vendors, consultants and other
    service providers who carry out work and perform services or functions on
    our behalf. For example, this may include vendors and service providers
    who engage in analytics, web hosting, or payment processing services.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Promotional Partners</strong>: We may
    disclose personal information in connection with providing contests or
    other promotional activities or otherwise promoting our Services and the
    services of our affiliates and trusted business partners.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Legal Obligations and Rights</strong>: We
    may disclose personal information in response to a request for information
    if we believe disclosure is in accordance with any applicable law,
    regulation or legal process or as otherwise required or permitted by any
    applicable law, rule or regulation. We may also disclose personal
    information if we believe your actions are inconsistent with our user
    agreements or policies or to protect the rights, property and safety of us
    or any third party.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>
      Business Transaction or Reorganization
    </strong>
    : We may disclose your personal information in connection with, or during
    negotiations of, any merger, acquisition, sale of Company assets,
    reorganization, financing or transfer of all or a portion of our business
    to another company.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Public Content</strong>: If you choose to
    submit content to us, we may publish this information by publicly posting,
    at our discretion, for example, your submissions, reviews, or other user
    content you provide us.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Consent</strong>: We may disclose your
    personal information with your consent or at your direction.
  </li>
</ul>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>5. THIRD PARTY SERVICES</strong>
</h5>
<p data-mce-fragment={1}>
  The Services may contain links to other websites and other websites may
  reference or link to the Services. These other domains and websites may not
  be controlled by us. We encourage our users to read the privacy policies of
  each and every website and application that they interact with. Except where
  we post, link to or expressly adopt or refer to this Privacy Policy, this
  Privacy Policy does not apply to, and we are not responsible for, any
  personal information practices of third-party websites and online services
  or the practices of other third parties.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>6. SECURITY OF YOUR INFORMATION</strong>
</h5>
<p data-mce-fragment={1}>
  We take steps to ensure that your information is treated securely and in
  accordance with this Privacy Policy.&nbsp; Unfortunately, the Internet
  cannot be guaranteed to be 100% secure, and we cannot ensure or warrant the
  security of any information you provide to us.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    7. CHOICES AND CONTROL OVER YOUR INFORMATION
  </strong>
</h5>
<ul data-mce-fragment={1}>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Profile and settings</strong>: You may
    update your account information and adjust your account settings by
    logging into your account. Please note that changes to your settings may
    require some time to take effect.
  </li>
  <li data-mce-fragment={1}>
    <strong data-mce-fragment={1}>Marketing Communications</strong>: You can
    stop receiving promotional email communications from us by clicking on the
    unsubscribe link provided in such communications. We make every effort to
    promptly process all unsubscribe requests. You may not opt out of
    service-related communications (e.g., account verification, transactional
    communications, changes/updates to features of the service, technical and
    security notices.)
  </li>
</ul>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>8. CHILDREN’S PRIVACY</strong>
</h5>
<p data-mce-fragment={1}>
  We do not knowingly collect, maintain, or use personal information from
  children under 13 years of age, and our Services are not directed to
  children under the age of 13. If you learn that a child under 13 has
  provided us with personal information without your consent,&nbsp;please
  contact us at info@alpine.design . If we learn that we have
  collected any Personal Information from children under 13, we will endeavor
  to promptly delete such information.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>9. COOKIES AND SIMILAR TECHNOLOGIES</strong>
</h5>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    <i data-mce-fragment={1}>What Information We Collect</i>
  </strong>
  <i data-mce-fragment={1}>:</i>
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Cookies</u>: We, and our third-party partners, may
  use cookies, pixel tags, local storage, and other tracking technologies to
  automatically collect information through the Services. These tracking
  technologies are small data files downloaded to or stored on your tablet,
  mobile phone or other internet-enabled device that enable us to record
  certain pieces of information whenever you visit or interact with our
  Services.
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Analytics:&nbsp;</u>We may collect analytics data
  or use third-party analytics tools such as Google Analytics to help us
  measure traffic and usage trends for our Services and to understand more
  about the demographics of our users.
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Interest-Based Advertising</u>: We may permit
  third-party online advertising networks, social media companies and other
  third-party services, to collect information about your use of our online
  Services over time so that they may play or display ads on our Services, on
  other websites, or services you may use, and on other devices you may use
  through tracking technologies, which recognize the device you are using and
  collect information, including click stream information, browser type, time
  and date you visited the site, AdID, geolocation and other information.
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Social Media</u>: Our Sites may include social
  media features, such as Facebook, Twitter, YouTube, Instagram or other
  widgets. These social media companies may recognize you and collect
  information about your visit to our Sites, and they may set a cookie or
  employ other tracking technologies. Your interactions with those features
  are governed by the privacy policies of those companies.
</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    <i data-mce-fragment={1}>How We Use Information We Collect</i>
  </strong>
  :
</p>
<p data-mce-fragment={1}>
  We may use data collected through cookies and other tracking technologies to
  (i) allow us to understand who has interacted with us; (ii) help us to
  operate our Services more efficiently; (iii) personalize your experience on
  the Services, (iv) improve our content and offerings, and (v) engage in
  analytics and measurement.&nbsp;
</p>
<p data-mce-fragment={1}>
  We and our third-party advertising partners also use this data to understand
  your browsing activities, including across unaffiliated third-party sites,
  so that we can deliver ads and information about products and services that
  may be of interest to you, and also to provide advertising-related services
  such as reporting, attribution, analytics and market research.
</p>
<p data-mce-fragment={1}>
  <strong data-mce-fragment={1}>
    <i data-mce-fragment={1}>
      Your Choices About Cookies and Online Advertising
    </i>
  </strong>
  :
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Cookies</u>: If you would prefer not accept cookies
  or tracking technologies, most browsers or devices will allow you to change
  your browser or device settings to disable existing cookies or set your
  browser to automatically reject such technologies. Please note that doing so
  could negatively affect the availability and functionality of the Services.
  Depending on your device and operating system, you may not be able to delete
  or block all such technologies. In addition, if you want to reject these
  technologies across all your browsers and devices, you will need to do so on
  each browser and device you actively use.
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Google Analytics</u>: You can learn more about
  Google's practices with Google Analytics by visiting Google's privacy policy
  here: https://policies.google.com/technologies/partner-sites. You can also
  view Google's currently available opt-out options here:
  https://tools.google.com/dlpage/gaoptout.
</p>
<p data-mce-fragment={1}>
  <u data-mce-fragment={1}>Interest-Based Advertising</u>: To opt-out of
  third-party interest-based advertising from advertisers and third parties
  that participate in certain self-regulatory programs, please visit the
  Network Advertising Initiative at: https://optout.networkadvertising.org and
  the Digital Advertising Alliance at: https://optout.aboutads.info. Opt-outs
  are generally device and browser specific, meaning that you will need to
  opt-out on each device and browser you use. Please note, even if you opt-out
  of interest-based advertising, you will still continue to receive generic
  ads.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>10. DATA TRANSFERS</strong>
</h5>
<p data-mce-fragment={1}>
  The Companies are based in the United States. Personal information collected
  through the Services will be transferred to and stored in offices of the
  Companies and its authorized third-party business vendors located in the
  United States or other countries, for the purposes described in this Privacy
  Policy. Please note that some of these countries may have data protection
  laws less stringent than or otherwise different from the laws in the country
  in which you are located.
</p>
<p data-mce-fragment={1}>&nbsp;</p>
<h5 data-mce-fragment={1}>
  <strong data-mce-fragment={1}>11. UPDATES TO THIS PRIVACY POLICY</strong>
</h5>
<p data-mce-fragment={1}>
  We will review and update the Privacy Policy from time to time.&nbsp; When
  we make changes to this Privacy Policy, we will change the “Last Updated”
  date at the top of this page. If we make material changes to this Privacy
  Policy, we will either notify you by prominent posting on the Services or as
  required by law. All changes shall be effective from the date of publication
  unless otherwise provided.
</p>
</div>

          </div>
        </div>

        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/privacyPolicy.js